import type { SsoContextValue } from '../sso/types';
import { getTokens } from '../tokens/localStorage';
import { canMakeAuthenticatedRequests } from './canMakeAuthenticatedRequests';

/**
 * Whether authenticated API calls may proceed for the current SSO session.
 * False during bootstrap refresh, session lock, or invalid/expired access token.
 */
export const getSessionReadyFromSso = (
  sso: SsoContextValue | null | undefined
): boolean => {
  if (!sso) {
    return true;
  }

  const { accessToken } = getTokens();

  return canMakeAuthenticatedRequests({
    ready: sso.ready,
    isRefreshing: sso.isRefreshing,
    sessionPhase: sso.sessionPhase,
    accessToken,
  });
};
